import { observer } from 'mobx-react-lite';
import StyleSettingsToggle from './StyleSettingsToggle';
import type { StyleSettingsToggleProps, StyleSettingsToggleValueProps } from './types';

export type { StyleSettingsToggleProps, StyleSettingsToggleValueProps };
export default observer(StyleSettingsToggle); // MANUAL OVERRIDE
